import PropTypes from "prop-types";
import { useState } from "react";
import { CircularProgress, Box, Button } from "@mui/material";
import { getInstructorsStudentRole } from "../../../components/Api/Getters";
import { fixInstructorsStudentRole } from "../../../components/Api/Updates";

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}
CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

export default function DataVerification(props) {
	const { value, token } = props;
	const [loading, setLoading] = useState(false);
	const [fixResultsMessage, setFixResultsMessage] = useState("");
	const [checked, setChecked] = useState(false);
	const [instructors, setInstructors] = useState({
		correct_role_count: 0,
		student_role_count: 0,
		student_role_list: [],
		not_exists: [],
	});
	const [error, setError] = useState("");
	const handleFetchInstructors = async () => {
		setError("");
		try {
			setLoading(true);
			const response = await getInstructorsStudentRole(token, 1940);
			const correct_role_count = response.correct_role_count || 0;
			const student_role_count = response.student_role_count || 0;
			const student_role_list = response.student_role_list || [];
			const not_exists = response.not_exists || [];
			setInstructors({
				correct_role_count,
				student_role_count,
				student_role_list,
				not_exists,
			});
			setLoading(false);
			setChecked(true);
		} catch (err) {
			setError("Failed to fetch instructors.");
			setLoading(false);
			console.error(err);
		}
	};

	const handleFixInstructors = async () => {
		try {
			setLoading(true);
			const fixResponse = await fixInstructorsStudentRole(
				token,
				1940,
				instructors.student_role_list,
			);
			setFixResultsMessage(fixResponse.message || "Instructor roles fixed successfully.");
			await handleFetchInstructors(); // Refresh the data after fixing
			setLoading(false);
		} catch (err) {
			setError("Failed to fix instructor roles.");
			setLoading(false);
			console.error(err);
		}
	};

	return (
		<CustomTabPanel value={value} index={5}>
			<div className="w-full border-2 flex flex-col gap-2 min-h-[40dvh]">
				<Button onClick={handleFetchInstructors} variant="contained" disabled={loading || checked}>
					{loading ? (
						<CircularProgress size={24} color="white" />
					) : (
						`Check Instructor Roles ${checked ? "(Checked - Refresh page to check again)" : ""}`
					)}
				</Button>
				{error && <p className="text-red-500">{error}</p>}
				{instructors && (
					<div className="text-black">
						<p>Correct Role Count: {instructors.correct_role_count}</p>
						<p>Student Role Count: {instructors.student_role_count}</p>
						<p>Student Role List (empid): {instructors.student_role_list.join(", ")}</p>
						<p>Not Exists: {instructors.not_exists.join(", ")}</p>
					</div>
				)}
				{instructors && instructors.student_role_list.length > 0 && (
					<div className="text-black">
						<Button
							variant="contained"
							color="primary"
							onClick={handleFixInstructors}
							disabled={loading}
						>
							Fix Instructor Roles
						</Button>
						{fixResultsMessage && <p className="text-green-500">{fixResultsMessage}</p>}
					</div>
				)}
			</div>
		</CustomTabPanel>
	);
}
